import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useDebounce } from "use-debounce";

const NotFound = () => {
  const navigate = useNavigate();

  const Value = sessionStorage.getItem("value");

  return (
    <div className="d-flex flex-column justify-content-center align-items-center py-60 bg-light text-center">
      <i className="bi bi-search display-3 text-secondary mb-3"></i>
      <h1 className="fs-4 text-dark mb-2">Search No Result</h1>
      <p className="fs-6 text-muted mb-3">
        We're sorry. We cannot find any matches for your search term.
      </p>
      <div className="mb-3">
        <strong className="fs-5 text-dark">0 items found for "{Value}"</strong>
      </div>

      <button
        onClick={() => navigate("/")}
        className="btn bg-main-600 text-white"
      >
        Go Back to Home
      </button>
    </div>
  );
};

export default NotFound;
